import { useState, useEffect } from 'react';

const RECENTLY_VIEWED_KEY = 'bloom_recently_viewed_stocks';

export default function useRecentlyViewed() {
  const [recentlyViewed, setRecentlyViewed] = useState<string[]>([]);

  useEffect(() => {
    const stored = localStorage.getItem(RECENTLY_VIEWED_KEY);
    if (stored) {
      try {
        setRecentlyViewed(JSON.parse(stored));
      } catch (e) {
        console.error('Failed to parse recently viewed stocks', e);
      }
    }
  }, []);

  const addRecentlyViewed = (symbol: string) => {
    setRecentlyViewed((prev) => {
      const filtered = prev.filter((s) => s !== symbol);
      const updated = [symbol, ...filtered].slice(0, 10);
      localStorage.setItem(RECENTLY_VIEWED_KEY, JSON.stringify(updated));
      return updated;
    });
  };

  return { recentlyViewed, addRecentlyViewed };
}
